import Sidebar from '../Sidebar';
import React, { useEffect, useState } from 'react'
import AmountDetail from './AmountDetail'
import BankDetails from './BankDetails'
import PaymentDetails from './PaymentDetails'
import { useLocation, useNavigate } from 'react-router-dom'
import authDashHelper from '../../../utils/AuthDashHelper';
import { getUserRecipient, pendingTransactions } from '../../../utils/Api';
import { commaRemover } from '../../../utils/hook';

//  FIXME: Loader glitch in step forwarding
const SendMoney = () => {

    const [loader, setLoader] = useState(false)
    const [step, setStep] = useState(0)
    const [previous, setPrevious] = useState(null)
    const navigate = useNavigate()
    const [display_confirm, setDisplayConfirm] = useState(false)

    const location = useLocation();

    const handleStep = (data) => {
        setStep(Number(data))
    }

    useEffect(() => {
        if (location?.state && location?.state?.transaction_id) {
            setLoader(true)
            const previous = location?.state?.transaction_id
            pendingTransactions().then(res => {
                if (res.code === "200") {
                    res?.data?.filter(async (item) => {
                        if (previous?.toString() === item?.id?.toString()) {
                            let prev_data = item
                            sessionStorage.setItem("transaction_id", item.transaction_id)
                            if (item?.recipient !== null || "") {
                                sessionStorage.setItem("rid", item?.recipient)
                            }
                            let local = {};
                            local.amount = { send_amt: commaRemover(item?.amount), exchange_amt: commaRemover(item?.receive_amount), exchange_rate: item?.exchange_rate, to_type: item?.receive_currency, from_type: item?.send_currency, recieve_meth: item?.recieve_meth || "Bank Transfer", payout_part: item?.payout_partner, part_type: item?.payout_partner };
                            if (item.amount && item.receive_currency && item.receive_amount && item.send_currency) {
                                let recipientData;
                                if (item.recipient && item.recipient_name) {
                                    recipientData = await getUserRecipient(item.recipient);
                                    if (recipientData.message === "Recipient does not exists!") {
                                        setStep(0);
                                        return;
                                    }
                                    local.recipient = {
                                        id: item.recipient, name: item.recipient_name, bank_name: recipientData.data.bank_name, account_type: recipientData.data.account_type,
                                        business_name: recipientData?.data?.business_name || "",
                                    };
                                    local.amount = { ...local.amount, payout_part: recipientData.data.bank_name, part_type: recipientData.data.bank_name }
                                    prev_data = { ...prev_data, payout_partner: recipientData?.data?.bank_name }
                                }

                                if (item.send_method && item.reason) {
                                    setDisplayConfirm(true)
                                    setStep(2)
                                } else {
                                    if (item.recipient && item.recipient_name) {
                                        setDisplayConfirm(true)
                                    }
                                    setStep(1)
                                }

                            }
                            setPrevious(prev_data)
                            sessionStorage.setItem("transfer_data", JSON.stringify(local))
                        }
                    })
                    setLoader(false)
                }
            })
        } else {
            setStep(0)
        }
    }, [])

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        })
        sessionStorage.setItem("send-step", step)
    }, [step])

    useEffect(() => {
        if (authDashHelper('dashCheck') === false) {
            navigate("/dashboard")
        }
    }, [])

    return (
        <div className="col-md-12">
            {loader ? <>
                <div className="loader-overly-dark" >
                    <div className="loader" >
                    </div>
                </div>
            </> : ""}
            {
                step === 0 ? <AmountDetail handleStep={handleStep} step={step} previous={previous} />
                    :
                    step === 1 ? <BankDetails handleStep={handleStep} step={step} previous={previous} confirmationDisplay={display_confirm} handleConfirmation={() => setDisplayConfirm(false)} />
                        :
                        step === 2 ? <PaymentDetails handleStep={handleStep} step={step} previous={previous} confirmationDisplay={display_confirm} confirmationHandler={() => setDisplayConfirm(false)} />
                            :
                            <></>
            }
        </div>
    )
}

export default SendMoney